import React from 'react';
import { Box, Flex, Stack, Text, Tooltip } from '@mantine/core';
import { MAIN_DARK_PRIMARY } from '../../../../constants/colors';
import { IconX } from '@tabler/icons';

export interface FilterModalHeaderProps {
  onClearAll: () => void;
  hasActiveFilters: () => boolean;
  hasClearableFilters?: boolean;
  clearAllDisabledHint?: string | null;
  onClose: () => void;
}

const FilterModalHeader: React.FC<FilterModalHeaderProps> = ({
  onClearAll,
  hasActiveFilters,
  hasClearableFilters = true,
  clearAllDisabledHint = null,
  onClose,
}) => {
  const active = hasActiveFilters();
  const canClear = active && hasClearableFilters;

  const clearAllDisabledTooltipLabel = !canClear
    ? clearAllDisabledHint ||
      'Nothing to clear yet.'
    : undefined;

  const clearAllControl = (
    <Box
      mr="sm"
      onClick={canClear ? onClearAll : undefined}
      sx={{
        cursor: canClear ? 'pointer' : 'default',
        opacity: canClear ? 1 : 0.5,
        '&:hover .clear-all-text': canClear
          ? {
            color: MAIN_DARK_PRIMARY,
          }
          : {},
      }}
    >
      <Text className="clear-all-text" fw={500} size="xs" sx={{ color: '#6b7280' }}>
        Clear all
      </Text>
    </Box>
  );

  return (
    <Flex justify="space-between" align="center" w="100%" /* gap="sm" */ py={16} pr={4}>
      <Box>
        <Text size="md" fw={600} c="#111827" lh={1.35} style={{ letterSpacing: '-0.01em' }}>
          Currently filtering by…
        </Text>
      </Box>
      <Flex align='center'>
        {clearAllDisabledTooltipLabel ? (
          <Tooltip label={clearAllDisabledTooltipLabel} withArrow position="bottom" multiline w={280}>
            <Box component="span" style={{ display: 'inline-block' }}>
              {clearAllControl}
            </Box>
          </Tooltip>
        ) : (
          clearAllControl
        )}

        <Stack
          onClick={onClose}
          title="Close modal"
          ml={8}
          mb={2}
          sx={{ 
            cursor: 'pointer',
            flexShrink: 0,
            marginLeft: 'auto',
            color: '#6b7280',
            '&:hover': { 
              color: MAIN_DARK_PRIMARY,
            },
          }}
        >
          <IconX size={14} />
        </Stack>
      </Flex>
      
    </Flex>
  );
};

export default FilterModalHeader;
